import axios from 'axios';

export default axios.create({
    baseURL: 'https://huiyi.envtime.com/',
    timeout: 10000
});



// WEBPACK FOOTER //
// ./src/api/index.js